/*
  Applicaton Wide Configs
 */

export const CLONE_FLAG = '~clone-';
export const WIZARD_FLAG = '~';

//
export const LOCALSTORAGEFIELDNAME = '%localstorage%!';

// 100 - Thin, Hairline
// 200 - Extra Light, Ultra Light
// 300 - Light
// 400 - Normal, Regular
// 500 - Medium
// 600 - Semi Bold, Demi Bold
// 700 - Bold
// 800 - Extra Bold, Ultra Bold
// 900 - Black, Heavy

export const BasemapLanguageChoices = [
  { name: 'Default', locale: 'default' },
  { name: 'German', locale: 'de' },
  { name: 'English', locale: 'en' },
  { name: 'French', locale: 'fr' },
  { name: 'Italian', locale: 'it' },
  { name: 'Spanish', locale: 'es' },
  { name: 'Endonym', locale: 'latin' },
  // { name: 'pt', locale: 'pt' },
  // { name: 'ru', locale: 'ru' },
];

/**
 * MESSAGE BUS related configs
 */

export enum MESSAGE_RECIPIENTS {
  All = 'ALL',
  Chart = 'CHART',
  Map = 'MAP',
  Table = 'TABLE',
  MapEditor = 'MAP_EDITOR',
  MapAttributor = 'MAP_ATTRIBUTOR',
  MapShapeEditor = 'MAP_SHAPE_EDITOR',
  MapOverlayWizard = 'MAP_OVERLAY_WIZARD',
  Atlas = 'ATLAS',
  Dash = 'DASH',
  Report = 'REPORT',
  Source = 'SOURCE',
  Editor = 'EDITOR',
  Legend = 'LEGEND',
  Filter = 'FILTER',
  ToolTip = 'TOOLTIP',
  ContentSelector = 'CONTENT_SELECTOR',
  Paywall = 'PAYWALL',
  Creator = 'CREATOR',
  UpdateDataEditor = 'UPDATE_DATA_EDITOR',
  InvisualFilter = 'INVISUAL_FILTER',
  LayoutSearch = 'LAYOUT_SEARCH',
}

export enum CREATOR_MESSAGE {
  OpenDataCreator = 'OPENDATACREATOR',
}

export enum PAYMENT_MESSAGES {
  OpenPaywall = 'OPENPAYWALL',
  ClosePaywall = 'CLOSE_PAYWALL',
}

export enum EVENT_MESSAGES {
  Click = 'EVENT_CLICK',
  Export = 'EVENT_EXPORT',
}

export enum EXPORT_MESSAGES {
  CSV = 'EXPORT_CSV',
  PDF = 'EXPORT_PDF',
  PNG = 'EXPORT_PNG',
  SVG = 'EXPORT_SVG',
  Excel = 'EXPORT_EXCEL',
}

export enum SUB_EDITOR_MESSAGES {
  UpdateLegendValues = 'UPDATELEGENDVALUES',
  CreatorModalOpened = 'CREATORMODALOPENED',
}

export enum EDITOR_MESSAGES {
  OpenTab = 'EDITOR_OPEN_TAB',
  SetFocus = 'EDITOR_OPEN_FOCUS',
  SetContentView = 'EDITOR_SET_CONTENT_VIEW',
  DisplayUpdate = 'EDITOR_DISPLAY_UPDATE',
  InvisUpdate = 'INVIS_UPDATE',
  InvisDropdownEditingActive = 'INVIS_DROPDOWN_EDITING_ACTIVE',
}

export enum TT_LINECHART_MESSAGES {
  ChartUpdated = 'CHART_UPDATED',
}

export enum MAP_MESSAGES {
  SetMapStyle = 'SET_MAP_STYLE',
  SetLanguage = 'SET_LANGUAGE',
  SetMapOption = 'SET_MAP_OPTON',
  BroadCastMapService = 'BROADCASTMAPSERVICE',
  RequestMapService = 'REQUEST_MAP_SERVICE',
  GetBoundingBox = 'REQUEST_MAP_BOUNDS',
  SetBoundingBox = 'RESPONSE_MAP_BOUNDS',
  UpdateEditor = 'UPDATE_EDITOR',
  AnimationPreview = 'REQUEST_ANIMATION_PREVIEW',
  SwitchRenderWorldCopies = 'SWITCH_RENDER_WORLD_COPIES',
  MapClick = 'MAP_CLICK',
  MapMove = 'MAP_MOVE',
  ShowConfigIndicators = 'SHOW_CONFIG_INDICATORS',
  SetLayoutProperty = 'SET_LAYOUT_PROPERTY',
  SetPaintProperty = 'SET_PAINT_PROPERTY',
  MoveLayer = 'MOVE_LAYER',
  RemoveLayer = 'REMOVE_LAYER',
  AddLayer = 'ADD_LAYER',
  RequestMapStyle = 'REQUEST_MAP_STYLE',
  AddMapAnnotation = 'ADD_MAP_ANNOTATION',
  SelectMapMarker = 'SELECT_MAP_MARKER',
  SelectMapMarkerMulti = 'SELECT_MAP_MARKER_MULTI',
  DetectChanges = 'DETECT_CHANGES',
  UnsavedChanges = 'UNSAVED_CHANGES',
  GetCenterPoint = 'GET_CENTER_POINT',
  GotCenterPoint = 'GOT_CENTER_POINT',
  OpenMarkerTooltip = 'OPEN_MARKER_TOOLTIP',
  CloseTooltip = 'CLOSE_TOOLTIP',
  ClusterUpdate = 'CLUSTER_UPDATE',
  ZoomToMarkers = 'ZOOM_TO_MARKERS',
  GetGLStyleJson = 'GET_GL_STYLE_JSON',
  SelectShapeLayer = 'SELECT_SHAPE_LAYER',
  UpdateLayers = 'UPDATE_MAP_LAYERS',
  UpdateSources = 'UPDATE_MAP_Sources',
  ShapeEdit = 'SHAPE_EDIT',
  ShapeDrawingMode = 'SHAPE_DRAWING_MODE',
  UpdateSelectedShapeSources = 'UPDATE_SELECTED_SHAPE_SOURCE',
  RecalculateViewport = 'RECALCULATE_VIEWPORT',
  UpdateNavigation = 'UPDATE_NAVIGATION',
}

export enum SPINNER_OVERLAY_MESSAGES {
  ShowSpinnerOverlay = 'SHOW_SPINNER',
  CloseSpinnerOverlay = 'CLOSE_SPINNER',
}

export enum REQUEST_TYPESWITCH_MESSAGES {
  ResetUp = 'REQ_TYPESWITCH_RESETUP',
}

export enum COLLECTION_MESSAGES {
  CollectionCreateSuccess = 'COLLECTION_CREATE_SUCCESS',
  CollectionCreateError = 'COLLECTION_CREATE_ERROR',
  CollectionCreate = 'COLLECTION_CREATE',
}

export enum SMART_SOURCE_MESSAGES {
  SmartSourceSaveIntent = 'REQ_SMART_SOURCE_SAVE_INTENT',
  SetUniqueness = 'REQ_SETUNIQUENESS',
}

export enum REQUEST_MESSAGES {
  InjectAutoCreatedVisual = 'REQ_INJECT_AUTOCREATED_VISUAL',
  ServerUpdateUserPreferences = 'REQ_SERVER_UPDATE_USER_PREFERENCES',
  ServerUpdateUserPreferencesAndStyle = 'REQ_SERVER_UPDATE_USER_PREFERENCES_AND_STYLE',
  ServerUpdateUserColors = 'REQ_SERVER_UPDATE_USER_COLORS',
  ServerUploadUserLogo = 'REQ_SERVER_UPLOAD_USER_LOGO',
  GetUserByID = 'REQ_GET_USER_BY_ID',
  BotExecuteFunction = 'REQ_BOT_EXECUTE_FUNCTION',
  ServerContentCreateFromExisting = 'REQ_SERVER_CREATE_CONTENT_FROM_EXISTING',
  RawData = 'REQ_RAW_DATA',
  DataPurge = 'REQ_DATA_PURGE',
  PreFilterData = 'RES_PRE_FILTER_DATA',
  RenderData = 'REQ_RENDER_DATA',
  DataUpdate = 'REQ_UPDATE_DATA',
  SmartFunctionData = 'REQ_SMART_FUNC_DATA',
  ContentBySlug = 'REQ_CONTENT_SLUG',
  ContentUpdate = 'REQ_CONTENT_UPDATE',
  ContentPurge = 'REQ_CONTENT_PURGE',
  ServerContentDelete = 'REQ_CONTENT_DELETE_SERVER',
  ServerContentRestore = 'REQ_CONTENT_RESTORE_SERVER',
  ServerFavoriteDelete = 'REQ_FAVORITE_DELETE_SERVER',
  ServerFavoriteAdd = 'REQ_FAVORITE_ADD_SERVER',
  ServerContentCreate = 'REQ_CONTENT_CREATE_SERVER',
  ServerContentUpdate = 'REQ_CONTENT_UPDATE_SERVER',
  InjectData = 'REQ_INJECT_DATA',
  FilterUpdate = 'REQ_FILTER_UPDATE',
  ReloadContentBySlug = 'REQ_RELOAD_CONTENT_BY_SLUG',
  ContentResize = 'REQ_CONTENT_RESIZE',
  AllDataIsFine = 'REQ_ALL_DATA_IS_FINE',
  DisplayScale = 'REQ_DISPLAY_SCALE',
  LanguageSwitch = 'REQ_LANGUAGE_SWITCH',
}

export enum RESPONSE_MESSAGES {
  InjectAutoCreatedVisual = 'RES_INJECT_AUTOCREATED_VISUAL',
  UpdateTag = 'RES_UPDATE_TAG',
  DeleteTag = 'RES_DELETE_TAG',
  MergeTag = 'RES_MERGE_TAG',
  // ServerUpdateUserPreferences = 'RES_SERVER_UPDATE_USER_PREFERENCES',
  // ServerUpdateUserPreferencesAndStyle = 'RES_SERVER_UPDATE_USER_PREFERENCES_AND_STYLE',
  // ServerUpdateUserColors = 'RES_SERVER_UPDATE_USER_COLORS',
  // ServerUploadUserLogo = 'RES_SERVER_UPLOAD_USER_LOGO',

  ServerUpdateUser = 'RES_SERVER_UPDATE_USER',

  GetUserByID = 'RES_GET_USER_BY_ID',
  ContentPurge = 'RES_CONTENT_PURGE',
  DataPurge = 'RES_DATA_PURGE',
  BotExecuteFunction = 'RES_BOT_EXECUTE_FUNCTION',
  ServerContentCreateFromExisting = 'RES_SERVER_CREATE_CONTENT_FROM_EXISTING',
  RawData = 'RES_RAW_DATA',
  PreFilterData = 'RES_PRE_FILTER_DATA',
  RenderData = 'RES_RENDER_DATA',
  DataUpdate = 'RES_UPDATE_DATA',
  SmartFunctionData = 'RES_SMART_FUNC_DATA',
  ContentBySlug = 'RES_CONTENT_SLUG',
  ContentUpdate = 'RES_CONTENT_UPDATE',
  InjectData = 'RES_INJECT_DATA',
  ServerFavoriteDelete = 'RES_FAVORITE_DELETE_SERVER',
  ServerFavoriteAdd = 'RES_FAVORITE_ADD_SERVER',
  ServerContentDelete = 'RES_CONTENT_DELETE_SERVER',
  ServerContentCreate = 'RES_CONTENT_CREATE_SERVER',
  ServerContentUpdate = 'RES_CONTENT_UPDATE_SERVER',
  ServerContentRestore = 'RES_CONTENT_RESTORE_SERVER',
  ReloadContentBySlug = 'RES_RELOAD_CONTENT_BY_SLUG',
  AllDataIsFine = 'RES_ALL_DATA_IS_FINE',
  DisplayScale = 'RES_DISPLAY_SCALE',
  LanguageSwitch = 'RES_LANGUAGE_SWITCH',
}

export const CSS_UNITS = ['px', 'em', 'rem', '%'];

export const MOBILE_BREAKPOINT = 450; // 420, 450, 480?

/**
 * Server side related Configs - Paths
 */
// console.log(import.meta.env, import.meta.env.NG_APP_VERSION, import.meta.env.NODE_ENV);

// export const SERVER = import.meta.env.SSR && import.meta.env.NODE_ENV === 'docker'; // environment.server;

// const NODE_ENV = import.meta.env.NODE_ENV;

// const SSR = import.meta.env.SSR;

// const LOCAL_SSR_PROXY_URL = 'http://localhost:2385';

// const DOCKER_PUB_SERVICE_URL = 'http://pub-service:7070/';

// const DOCKER_API_V1_URL = `${DOCKER_PUB_SERVICE_URL}api/v1`;

// const DOCKER_API_V2_URL = `${DOCKER_PUB_SERVICE_URL}api/v2`;

// const DOCKER_API_V3_URL = 'http://backend:23050';

// const DOCKER_PUBLIC_DATA_SERVICE_URL = `${DOCKER_PUB_SERVICE_URL}public/data/`;

// const DOCKER_ACCESS_CONTROL_URL = 'http://access-control:20815';

// const DOCKER_LANGUAGE_URL = `${DOCKER_API_V2_URL}/languages/`;

// const DOCKER_GEO_API_URL = 'http://gateway/api/v1/utilities/geo';

// const getPublicationUrl = () => {
//   if (SSR) {
//     if (NODE_ENV === 'docker') {
//       return DOCKER_PUB_SERVICE_URL;
//     }
//     return `${LOCAL_SSR_PROXY_URL}/services/`;
//   }
//   return '/services/';
// };

// const getPublicationPublicUrl = () => {
//   if (SSR) {
//     if (NODE_ENV === 'docker') {
//       return DOCKER_PUB_SERVICE_URL;
//     }
//     return `${LOCAL_SSR_PROXY_URL}/services/pub/`;
//   }
//   return '/services/pub/';
// };

// const getPublicDataUrl = () => {
//   if (SSR) {
//     if (NODE_ENV === 'docker') {
//       return DOCKER_PUBLIC_DATA_SERVICE_URL;
//     }
//     return `${LOCAL_SSR_PROXY_URL}/services/publicdata/`;
//   }
//   return '/services/publicdata/';
// };

// const getApiV1Url = () => {
//   if (SSR) {
//     if (NODE_ENV === 'docker') {
//       return DOCKER_API_V1_URL;
//     }
//     return `${LOCAL_SSR_PROXY_URL}/services/pub/api/v1`;
//   }
//   return '/services/pub/api/v1';
// };

// const getApiV2Url = () => {
//   if (SSR) {
//     if (NODE_ENV === 'docker') {
//       return DOCKER_API_V2_URL;
//     }
//     return `${LOCAL_SSR_PROXY_URL}/api/v2`;
//   }
//   return '/api/v2';
// };

// const getApiV3Url = () => {
//   if (SSR) {
//     if (NODE_ENV === 'docker') {
//       return DOCKER_API_V3_URL;
//     }
//     return `${LOCAL_SSR_PROXY_URL}/api/v3`;
//   }
//   return '/api/v3';
// };

// const getAccessControlUrl = () => {
//   if (SSR) {
//     if (NODE_ENV === 'docker') {
//       return DOCKER_ACCESS_CONTROL_URL;
//     }
//     return `${LOCAL_SSR_PROXY_URL}/services/access-control`;
//   }
//   return '/services/access-control';
// };

// const getLanguageUrl = () => {
//   if (SSR) {
//     if (NODE_ENV === 'docker') {
//       return DOCKER_LANGUAGE_URL;
//     }
//     return `${LOCAL_SSR_PROXY_URL}/api/v2/languages/`;
//   }
//   return '/api/v2/languages/';
// };

// const getNewGeoAPiUrl = () => {
//   if (SSR) {
//     if (NODE_ENV === 'docker') {
//       return DOCKER_GEO_API_URL;
//     }
//     return LOCAL_SSR_PROXY_URL;
//   }
//   return '/api/v1/utilities/geo';
// };

// // Sets the right urls on client and server!
// // VERY IMPORTANT SETTINGS STILL IN USE
// export const PUBLIC_PUBLICATION_PATH = getPublicationUrl(); // SERVER ? 'http://pub-service:7070/' : '/services/';
// export const PUBLIC_PUBLICATION_PATH_PUB = getPublicationPublicUrl(); // SERVER ? 'http://pub-service:7070/' : '/services/pub/';
// export const PUBLIC_DATA_PATH = getPublicDataUrl(); // SERVER ? 'http://pub-service:7070/public/data/' : '/services/publicdata/';
// export const ACCESS_CONTROL_PATH = getAccessControlUrl(); //SERVER ? 'http://access-control:20815' : '/services/access-control';
// export const LANGUAGE_PATH = getLanguageUrl(); //SERVER ? 'http://pub-service:7070/api/v2/languages/' : '/api/v2/languages/';
// export const APIV3 = getApiV3Url(); //SERVER ? 'http://backend:23050' : '/api/v3';
// export const APIV2 = getApiV2Url(); //SERVER ? 'http://backend:23050' : '/api/v3';
// export const APIV1 = getApiV1Url();
// export const NEW_GEO_API_PATH = getNewGeoAPiUrl(); // SERVER ? 'http://gateway/api/v1/utilities/geo' : '/api/v1/utilities/geo';

// export const ContentPublic = `${PUBLIC_PUBLICATION_PATH}public/content`;
// export const GaCodeApi = `${PUBLIC_PUBLICATION_PATH}public/gacode`;
// export const MetricApi = `${PUBLIC_PUBLICATION_PATH}pub/api/v1/record/metrics/`;
// export const StripeKeyApi = `${PUBLIC_PUBLICATION_PATH}public/stripekey`;
// export const OctobatKeyApi = `${PUBLIC_PUBLICATION_PATH}public/octobatkey`;
// export const CONTENT_API = `${PUBLIC_PUBLICATION_PATH_PUB}api/v1/content`;
// export const FILES_API = `${PUBLIC_PUBLICATION_PATH}api/v2/files`;
// export const TAGS_API = `${PUBLIC_PUBLICATION_PATH_PUB}api/v1/tags`;
// export const BLOG_API = `${PUBLIC_PUBLICATION_PATH}public/blog`;
// // export const APIV2 = SERVER ? 'http://pub-service:7070/api/v2' : '/api/v2';
// // export const APIV1 = SERVER ? `${PUBLIC_PUBLICATION_PATH_PUB}api/v1` : '/services/pub/api/v1';

// export const GEO_API_PATH = `${PUBLIC_PUBLICATION_PATH_PUB}api/v1/geo`;
// export const GEO_PUBLIC_API_PATH = `${PUBLIC_PUBLICATION_PATH}public/geo`;

